/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var DashboardOutlineIcon = function DashboardOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M20 16C20 13.936 19.2183 12.0545 17.9349 10.6355L19.1155 8.97363C20.899 10.7796 22 13.2612 22 16V17H20V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12.6885 6 13.3608 6.06959 14.0102 6.20211L12.7109 8.03115C12.4767 8.01053 12.2396 8 12 8C7.58172 8 4 11.5817 4 16V17H2V16C2 10.4772 6.47715 6 12 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3026 7.59841C16.0171 6.61741 17.5337 7.51727 17.015 8.61447L13.2947 16.4852C12.8362 17.4552 11.6427 17.8203 10.72 17.2729C9.79736 16.7254 9.54583 15.5028 10.1774 14.6356L15.3026 7.59841Z"
  }));
};
export default DashboardOutlineIcon;